import { Component, OnInit, Input } from '@angular/core';
import { Organization } from '../../../organization-models';

@Component({
  selector: 'adm-organization-logo',
  templateUrl: './organization-logo.component.html',
  styleUrls: ['./organization-logo.component.scss'],
})
export class OrganizationLogoComponent {
  @Input() organization: Organization;
}
